import PropTypes from 'prop-types'
import MenuPrincipal from './MenuPrincipal'

const ContenedorMenu = (props) => {
  return <MenuPrincipal mostrarAyuda={props.mostrarAyuda} />
}

ContenedorMenu.propTypes = {
  mostrarAyuda: PropTypes.func.isRequired
}

export default ContenedorMenu
